import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '@payer-admin-ui/components-v2/src/labels/StatusChip';

export const SessionsStatusChips = ({
  sessionAlerts: { pendingCount, failedCount, manualControlCount, errorCount },
}) => {
  const { t } = useTranslation();

  return (
    <>
      {pendingCount > 0 && (
        <StatusChip
          text={pendingCount}
          color="secondary"
          tooltip={{ content: t('onboard.customer.listView.pendingSessions', { count: pendingCount }) }}
        />
      )}
      {failedCount > 0 && (
        <StatusChip
          text={failedCount}
          color="warning"
          tooltip={{ content: t('onboard.customer.listView.failedSessions', { count: failedCount }) }}
        />
      )}
      {errorCount > 0 && (
        <StatusChip
          text={errorCount}
          color="danger"
          tooltip={{ content: t('onboard.customer.listView.errorSessions', { count: errorCount }) }}
        />
      )}
      {manualControlCount > 0 && (
        <StatusChip
          text={manualControlCount}
          color="primary"
          tooltip={{ content: t('onboard.customer.listView.manualControlSessions', { count: manualControlCount }) }}
        />
      )}
    </>
  );
};

SessionsStatusChips.propTypes = {
  sessionAlerts: PropTypes.shape({
    pendingCount: PropTypes.number,
    failedCount: PropTypes.number,
    manualControlCount: PropTypes.number,
    errorCount: PropTypes.number,
  }).isRequired,
};
